<!--OFFER TEXT-->
<!--
<section class="offer-text-wrp uk-flex uk-flex-middle uk-flex-center">
  <div class="line-left"></div>
  <div class="offer-text-card text-center">
    <h4>Treat life like Beer, chill for best results.</h4>
    <p>40% of human jobs can be replaced by AI in the near future.</p>

    <p>We’re bringing the future to your present by customizing the perfect experience for you.</p>
  </div>
  <div class="line-right"></div>
</section>
-->

<!--FOOTER 24-sep-vip-->
<footer>
    <div class="footer-wrp">
        <div class="container">
            <div class="uk-flex uk-flex-wrap footer-wrp-inner">
                <div class="w-25">
                    <div class="footer-panel-left">
                        <ul uk-accordion="collapsible: false">
                            <li class="uk-open">
                                <a class="uk-accordion-title" href="#">
                                    <h4>Exclusives</h4>
                                </a>
                                <div class="uk-accordion-content">
                                    <ul class="list" *ngIf="categoriesReceived">
                                        <li *ngFor="let category of categories.EXPERIENCE">
                                            <a [routerLink]="['/'+footerSelectedCity.toLowerCase()+'/exclusives/'+category.slug]" class="{{currentCategoryID === category.id || category.slug == currentCategorySlug? 'active uk-active':''}}">{{category.category_name
                                                }}</a>
                                        </li>
                                    </ul>

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="w-25">
                    <div class="footer-panel-left list2">
                        <ul uk-accordion="collapsible: false">
                            <li class="uk-open">
                                <a class="uk-accordion-title" href="#">
                                    <h4>DEALS</h4>
                                </a>
                                <div class="uk-accordion-content">
                                    <ul class="list" *ngIf="categoriesReceived">
                                        <li *ngFor="let category of categories.STANDARD">
                                            <a [routerLink]="['/'+footerSelectedCity.toLowerCase()+'/deals/'+category.slug]" class="{{currentCategoryID === category.id || category.slug == currentCategorySlug? 'active uk-active':''}}">{{category.category_name
                                                }}</a>
                                        </li>
                                    </ul>

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="w-25">
                    <div class="footer-panel-left list2">
                        <ul uk-accordion="collapsible: false">
                            <li class="uk-open">
                                <a class="uk-accordion-title" href="#">
                                    <h4>Things2do</h4>
                                </a>
                                <div class="uk-accordion-content">
                                    <ul class="list">
                                        <li>
                                            <a [routerLink]="['/'+appService.getCurrentCity().toLowerCase()+'/deals']">Home</a>
                                        </li>
                                        <li>
                                            <a href="/blogs/">Blogs</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/contact-us']">Contact us</a>
                                        </li>
                                        <!-- <li>
                                            <a [routerLink]="['/corporate-booking']">Corporate booking</a>
                                        </li> -->
                                        <li>
                                            <a [routerLink]="['/faqs']">FAQs</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/terms-and-conditions']">Terms and conditions</a>
                                        </li>
                                        <!-- <li>
                                            <a [routerLink]="['/reschedule-time']">Reschedule</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/order-confirmation-status']">order-confirmation</a>
                                        </li> -->

                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="w-25">
                    <div class="footer-panel-right">

                        <div class="number">
                            <h4>Call Us On</h4>
                            <a href="tel:18002667666">
                                <!--<img src="assets/images/icons/phone.png" alt="">-->
                                <i class="fa fa-phone"></i> 1800 266 7666
                            </a>
                        </div>
                        <div class="email mt-3">
                            <!--<img src="assets/images/icons/message.png" alt="">-->
                            <i class="fa fa-envelope"></i>
                            <a href="mailto:info@things2do.email">support@things2.do</a>
                        </div>

                        <div class="social-box">
                            <a href="https://twitter.com/_things2do?lang=en" target="_blank">
                                <i class="fa fa-twitter"></i>
                            </a>
                            <a href="https://www.youtube.com/channel/UCuWnMoB_PIfKr2U4AVjjsfA" target="_blank">
                                <i class="fa fa-youtube-play"></i>
                            </a>
                            <a href="https://www.instagram.com/things2doexperiences/" target="_blank">
                                <i class="fa fa-instagram"></i>
                            </a>
                            <a href="https://in.linkedin.com/company/things2-do" target="_blank">
                                <i class="fa fa-linkedin"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom {{extraClass}}">
        <div class="container w-1020 uk-flex uk-flex-between">
            <div class="policy-link">

            </div>
            <p>Copyright © 2017 - 2022 things2do. All rights reserved.</p>
        </div>
    </div>
</footer>
<!--FOOTER-->